/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestionWithAnswer } from './QuestionWithAnswer';
import {
    QuestionWithAnswerFromJSON,
    QuestionWithAnswerFromJSONTyped,
    QuestionWithAnswerToJSON,
    QuestionWithAnswerToJSONTyped,
} from './QuestionWithAnswer';

/**
 * 
 * @export
 * @interface ComplianceChecklist
 */
export interface ComplianceChecklist {
    /**
     * 
     * @type {number}
     * @memberof ComplianceChecklist
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof ComplianceChecklist
     */
    readonly categoryName: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof ComplianceChecklist
     */
    readonly categoryDomains: Array<any>;
    /**
     * 
     * @type {string}
     * @memberof ComplianceChecklist
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ComplianceChecklist
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof ComplianceChecklist
     */
    numQuestions?: number;
    /**
     * 
     * @type {string}
     * @memberof ComplianceChecklist
     */
    descriptionInitial?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ComplianceChecklist
     */
    descriptionBasic?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ComplianceChecklist
     */
    descriptionIntermediate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ComplianceChecklist
     */
    descriptionAdvanced?: string | null;
    /**
     * 
     * @type {Array<QuestionWithAnswer>}
     * @memberof ComplianceChecklist
     */
    readonly questions: Array<QuestionWithAnswer>;
    /**
     * 
     * @type {string}
     * @memberof ComplianceChecklist
     */
    readonly score: string;
    /**
     * 
     * @type {string}
     * @memberof ComplianceChecklist
     */
    readonly lastAssessed: string;
    /**
     * 
     * @type {string}
     * @memberof ComplianceChecklist
     */
    readonly globalScore: string;
    /**
     * 
     * @type {string}
     * @memberof ComplianceChecklist
     */
    readonly progress: string;
}

/**
 * Check if a given object implements the ComplianceChecklist interface.
 */
export function instanceOfComplianceChecklist(value: object): value is ComplianceChecklist {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('categoryName' in value) || value['categoryName'] === undefined) return false;
    if (!('categoryDomains' in value) || value['categoryDomains'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('questions' in value) || value['questions'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    if (!('lastAssessed' in value) || value['lastAssessed'] === undefined) return false;
    if (!('globalScore' in value) || value['globalScore'] === undefined) return false;
    if (!('progress' in value) || value['progress'] === undefined) return false;
    return true;
}

export function ComplianceChecklistFromJSON(json: any): ComplianceChecklist {
    return ComplianceChecklistFromJSONTyped(json, false);
}

export function ComplianceChecklistFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceChecklist {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'categoryName': json['category_name'],
        'categoryDomains': json['category_domains'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'numQuestions': json['num_questions'] == null ? undefined : json['num_questions'],
        'descriptionInitial': json['description_initial'] == null ? undefined : json['description_initial'],
        'descriptionBasic': json['description_basic'] == null ? undefined : json['description_basic'],
        'descriptionIntermediate': json['description_intermediate'] == null ? undefined : json['description_intermediate'],
        'descriptionAdvanced': json['description_advanced'] == null ? undefined : json['description_advanced'],
        'questions': ((json['questions'] as Array<any>).map(QuestionWithAnswerFromJSON)),
        'score': json['score'],
        'lastAssessed': json['last_assessed'],
        'globalScore': json['global_score'],
        'progress': json['progress'],
    };
}

  export function ComplianceChecklistToJSON(json: any): ComplianceChecklist {
      return ComplianceChecklistToJSONTyped(json, false);
  }

  export function ComplianceChecklistToJSONTyped(value?: Omit<ComplianceChecklist, 'id'|'category_name'|'category_domains'|'questions'|'score'|'last_assessed'|'global_score'|'progress'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'num_questions': value['numQuestions'],
        'description_initial': value['descriptionInitial'],
        'description_basic': value['descriptionBasic'],
        'description_intermediate': value['descriptionIntermediate'],
        'description_advanced': value['descriptionAdvanced'],
    };
}

